export default {"src":"/_next/static/media/PRJ.a57de3ec.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};